import {Media, MediaState} from '../interfaces';

export const getters = {
  medias: (state: MediaState): Media[] => state.medias,
  hasMedias: (state: MediaState): boolean => state.medias.length > 0,
  hasOneMedia: (state: MediaState): boolean => state.medias.length === 1,
};
